export type FilterBuilding = {
  key: string
  name: string
  displayName?: string
  city: { key: string; name: string }
}

export interface buildingsArrayProps {
  value: string
  label: string
  id?: string
}

export interface regionsArrayProps {
  value: string
  label: string
  id: string
}

export const VIEW_ALL_REGION: regionsArrayProps = { id: 'all', label: 'All locations', value: 'all' }
export const VIEW_ALL_BUILDING: buildingsArrayProps = { id: 'all', label: 'View All', value: 'all' }

export const getRegionOptions = (buildings: FilterBuilding[]): regionsArrayProps[] => {
  const regions = new Map<string, regionsArrayProps>()
  buildings.forEach(({ city }) => {
    if (!regions.has(city.key)) regions.set(city.key, { value: city.key, label: city.name, id: city.key })
  })
  return [VIEW_ALL_REGION, ...regions.values()]
}

export const getBuildingOptions = (buildings: FilterBuilding[], region: string): buildingsArrayProps[] => {
  const options = buildings
    .filter((b) => b.city.key === region)
    .map((b) => ({ value: b.name, label: b.displayName || b.name, id: b.key }))
  return options.length > 1 ? [VIEW_ALL_BUILDING, ...options] : options
}
